<script setup lang="ts">
import GeneralSearch from '@/components/Search/GeneralSearch.vue'
import { authService } from '@/core/sso/oidc/AuthService'
import { useLayout } from '@/layout/composables/layout'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { toggleMenu, toggleDarkMode, isDarkTheme } = useLayout()

const { t } = useI18n()
const router = useRouter()

const onLogoutClick = () => {
  authService.logout()
}

const onProfileClick = () => {
  router.push('/profile')
}

const { layoutState } = useLayout()
</script>

<template>
  <div class="layout-topbar">
    <div class="flex flex-wrap layout-topbar-logo-container">
      <div v-if="layoutState.mobileMenu">
        <button class="layout-menu-button layout-topbar-action" @click="toggleMenu" v-tooltip.bottom="t('navbar.toggleMenu')">
          <i class="pi pi-bars"></i>
        </button>
      </div>
      <div class="pl-3 flex justify-content-start">
        <router-link to="/">
          <img src="@/assets/allego_logo.svg" alt="logo" class="h-2rem" />
        </router-link>
      </div>
    </div>
    <div class="w-[50%] layout-logo-container">
      <GeneralSearch />
    </div>
    <div class="layout-topbar-actions">
      <div class="layout-config-menu">
        <button type="button" class="layout-topbar-action" @click="toggleDarkMode">
          <i :class="['pi', { 'pi-moon': isDarkTheme, 'pi-sun': !isDarkTheme }]"></i>
        </button>
      </div>

      <button
        class="layout-topbar-menu-button layout-topbar-action"
        v-styleclass="{
          selector: '@next',
          enterFromClass: 'hidden',
          enterActiveClass: 'animate-scalein',
          leaveToClass: 'hidden',
          leaveActiveClass: 'animate-fadeout',
          hideOnOutsideClick: true
        }"
      >
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <button type="button" class="layout-topbar-action" v-tooltip.bottom="t('navbar.userPreferences')" @click="onProfileClick()">
            <i class="pi pi-user"></i>
          </button>
          <Divider layout="vertical" />
          <button @click="onLogoutClick()" v-tooltip.bottom="t('navbar.logout')" class="layout-topbar-action mr-2">
            <i class="pi pi-sign-out"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.layout-logo-container {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>
